import { SleeveInfo } from '@blk/aw-bff-typescript-models';
import { FilterDefinition } from '@blk/awt-aladdinportfoliobuilderserver';
import { AxiosResponse, CancelToken } from 'axios';
import { isEmpty } from 'lodash';
import { AGraphWrappedType, unwrapAGraphResponse } from '../../utils/AGraphWrapper';
import { awPortfolioApi } from './Base';

export type SleeveInfoTagValuePair = {
  tag: string;
  value: string;
};

export interface SearchSleeveResponse {
  nextPageToken: string | null;
  sleeves: SleeveInfo[];
}

export interface FieldCategory {
  count: number;
  name: string;
}

export interface SleeveInfoCountResponse {
  countByFields: {
    [key: string]: FieldCategory[];
  };
}

export type EnhancedSleeveInfo = SleeveInfo & {
  id: string;
};

const QUERY_LIMIT = 1000;

export async function bulkGetSleeveInfo(
  asOf: string,
  sleeveInfoTagValuePairs: SleeveInfoTagValuePair[],
  pkg: string,
  cancelToken?: CancelToken
): Promise<AxiosResponse<SleeveInfo[]>> {
  const path = 'sleeve-info/bulkGet';
  const response = await awPortfolioApi.post<AGraphWrappedType<SleeveInfo[], 'items'>>(
    path,
    { sleeveInfoTagValuePairs },
    { params: { asOf, pkg }, cancelToken }
  );
  return unwrapAGraphResponse(response, 'items');
}

// this api function is used for fetching all sleeve info (with pagination)
export function fetchSleeveInfo(
  asOf: string,
  cursor?: string,
  limit?: number,
  userInput?: string,
  appliedFilters?: FilterDefinition[],
  cancelToken?: CancelToken
): Promise<AxiosResponse<SearchSleeveResponse>> {
  const path = 'sleeve-info/search';
  return awPortfolioApi.post<SearchSleeveResponse>(
    path,
    {
      filterParams: !isEmpty(appliedFilters) ? [{ filters: appliedFilters, operationType: 'AND' }] : [],
    },
    { params: { asOf: `${asOf}T00:00:00Z`, limit: limit ?? QUERY_LIMIT, cursor, userInput }, cancelToken }
  );
}

export function fetchSleeveCount(
  asOf: string,
  colTag: string,
  appliedFilters?: FilterDefinition[]
): Promise<AxiosResponse<SleeveInfoCountResponse>> {
  const path = 'sleeve-info/count';
  return awPortfolioApi.post<SleeveInfoCountResponse>(
    path,
    {
      filterParams: !isEmpty(appliedFilters) ? [{ filters: appliedFilters, operationType: 'AND' }] : [],
      countFields: [colTag],
    },
    { params: { asOf: `${asOf}T00:00:00Z` } }
  );
}
